<template>
  <div
    class="p-4 bg-white rounded-lg mb-3 flex items-start"
    @click="handleClick"
  >
    <i
      class="sr-2 sr-v2-arrow-right-circle text-blue-300 transform -rotate-90 block ds-text-xl mr-2"
    />
    <div class="mr-2 w-full">
      <div
        class="text-gray-1000 ds-text-base md:ds-text-xl font-bold flex flex-row justify-between"
      >
        <div class="mr-2 flex-1 select-none cursor-pointer">{{ label }}</div>
        <div class="flex items-start">
          <span
            class="hidden md:inline-block text-blue-300 ds-text-base font-semibold mr-1 select-none cursor-pointer"
            >{{ isClosed ? "More" : "Less" }}</span
          >
          <i
            class="sr-2 sr-v2-chevron text-blue-300 transform-all block ds-text-xl duration-300 select-none cursor-pointer"
            :class="{ 'rotate-180': !isClosed }"
          />
        </div>
      </div>

      <div
        class="h-0 text-gray-900 ds-text-base transform-all duration-300"
        :class="{
          'h-auto block mt-4 ': !isClosed,
        }"
      >
        <p v-if="!isClosed" v-html="desc"></p>
      </div>
    </div>
  </div>
</template>

<script>
import tracking from "../../utils/tracking";

export default {
  data: () => ({
    isClosed: true,
  }),
  props: {
    label: { type: String },
    desc: { type: String },
  },
  methods: {
    handleClick(e) {
      if (e.target.dataset.faq) {
        this.$parent.$parent.$emit("triggerFaq", {
          faq: e.target.dataset.faq,
          index: +e.target.dataset.index,
        });
      } else {
        this.isClosed = !this.isClosed;
      }

      this.$nextTick(() => {
        if (!this.isClosed) {
          tracking.feature({
            event: "clicked_feature_info",
            cta_location: this.label,
          });
        }
      });
    },
  },
};
</script>

<style>
</style>